import React from 'react';
import { BanIcon, BatteryLowIcon, HelpCircleIcon, MoonIcon, PillIcon, RefreshCwIcon, FrownIcon } from 'lucide-react';
import { Highlight } from '../Highlight';
import { costOfInaction } from '../../data/landing';
const icons = [PillIcon, FrownIcon, BanIcon, HelpCircleIcon, MoonIcon, BatteryLowIcon, RefreshCwIcon];
export function CostOfInaction() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-82" data-mp="2csudu1969y1s">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center" data-id="element-83" data-mp="2cunl9irm0mau">
        <div className="text-center lg:text-left" data-id="element-84" data-mp="280t86y6if5kq">
          <h2 className="text-4xl font-black uppercase leading-[1] tracking-tight text-brand md:text-6xl" data-id="element-85" data-mp="2331cdt2quzb9">
            ¿Cuánto cuesta <span className="text-danger" data-id="element-86" data-mp="1y59d2dzrsax1">no tenerlo?</span>
          </h2>
          <p className="mt-8 text-3xl font-black leading-snug text-brand md:text-4xl" data-id="element-87" data-mp="1t4vb9dorhx7g">
            “El próximo domingo puede ser <Highlight data-id="element-88" data-mp="1p39u3g572wrg">diferente.</Highlight>”
          </p>
        </div>

        <div className="rounded-3xl border border-danger/20 bg-danger-soft p-6 md:p-8" data-id="element-89" data-mp="mdgylmf392tg">
          <p className="text-sm font-black uppercase tracking-[0.2em] text-danger" data-id="element-90" data-mp="r3xbn5ezymfa">Sin MegaPack</p>
          <ul className="mt-4 divide-y divide-danger/15" data-id="element-91" data-mp="cf173ic5frjf">
            {costOfInaction.map((c, i) => {
            const Icon = icons[i];
            return <li key={c.title} className="flex items-center gap-4 py-3.5" data-id="element-92" data-mp="henmnyfg9jve" data-mpi={i}>
                  <Icon className="h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-93" data-mp="154q6jr97njix" />
                  <span className="font-bold text-charcoal" data-id="element-94" data-mp="1a31jwbypsc5w">{c.title}</span>
                  <span className="ml-auto text-right text-sm text-muted" data-id="element-95" data-mp="w3a90k3hvbw4">{c.detail}</span>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}